// @ts-nocheck

import React from 'react';

import Font28DaysLater from '../assets/fonts/28DaysLater.ttf';
import ArchivoNarrowBoldTtf from '../assets/fonts/ArchivoNarrow-Bold.ttf';
import ArchivoNarrowBoldItalicTtf from '../assets/fonts/ArchivoNarrow-BoldItalic.ttf';
import ArchivoNarrowItalicTtf from '../assets/fonts/ArchivoNarrow-Italic.ttf';
import ArchivoNarrowMediumTtf from '../assets/fonts/ArchivoNarrow-Medium.ttf';
import ArchivoNarrowMediumItalicTtf from '../assets/fonts/ArchivoNarrow-MediumItalic.ttf';
import ArchivoNarrowRegularTtf from '../assets/fonts/ArchivoNarrow-Regular.ttf';
import ArchivoNarrowSemiBoldTtf from '../assets/fonts/ArchivoNarrow-SemiBold.ttf';
import ArchivoNarrowSemiBoldItalicTtf from '../assets/fonts/ArchivoNarrow-SemiBoldItalic.ttf';
import BebasNeueEot from '../assets/fonts/BebasNeue-webfont.eot';
import BebasNeueSvg from '../assets/fonts/BebasNeue-webfont.svg';
import BebasNeueTtf from '../assets/fonts/BebasNeue-webfont.ttf';
import BebasNeueWoff from '../assets/fonts/BebasNeue-webfont.woff';
import ChangaOneRegular from '../assets/fonts/ChangaOne-Regular.ttf';
import CountbachOtf from '../assets/fonts/Countbach.otf';
import CountbachWoff from '../assets/fonts/Countbach.woff';
import CountbachWoff2 from '../assets/fonts/Countbach.woff2';
import DropDeadGorgeousTtf from '../assets/fonts/drop-dead-gorgeous.ttf';
import KalamBold from '../assets/fonts/Kalam-Bold.ttf';
import KalamLight from '../assets/fonts/Kalam-Light.ttf';
import KalamRegular from '../assets/fonts/Kalam-Regular.ttf';
import KBLH45 from '../assets/fonts/KBLH45.otf';
import KBLH55 from '../assets/fonts/KBLH55.otf';
import KBLH65 from '../assets/fonts/KBLH65.otf';
import KBLH75 from '../assets/fonts/KBLH75.otf';
import KBLH85 from '../assets/fonts/KBLH85.otf';
import MoneyTime from '../assets/fonts/MoneyTimeV7-Regular.woff';
import PoliticaBoldEot from '../assets/fonts/Politica-Bold.eot';
import PoliticaBoldSvg from '../assets/fonts/Politica-Bold.svg';
import PoliticaBoldTtf from '../assets/fonts/Politica-Bold.ttf';
import PoliticaBoldWoff from '../assets/fonts/Politica-Bold.woff';
import PoliticaBoldWoff2 from '../assets/fonts/Politica-Bold.woff2';
import PoliticaExtraBoldEot from '../assets/fonts/Politica-ExtraBold.eot';
import PoliticaExtraBoldSvg from '../assets/fonts/Politica-ExtraBold.svg';
import PoliticaExtraBoldTtf from '../assets/fonts/Politica-ExtraBold.ttf';
import PoliticaExtraBoldWoff from '../assets/fonts/Politica-ExtraBold.woff';
import PoliticaExtraBoldWoff2 from '../assets/fonts/Politica-ExtraBold.woff2';
import PoliticaExtraBoldItalicEot from '../assets/fonts/Politica-ExtraBoldItalic.eot';
import PoliticaExtraBoldItalicSvg from '../assets/fonts/Politica-ExtraBoldItalic.svg';
import PoliticaExtraBoldItalicTtf from '../assets/fonts/Politica-ExtraBoldItalic.ttf';
import PoliticaExtraBoldItalicWoff2 from '../assets/fonts/Politica-ExtraBoldItalic.woff';
import PoliticaExtraBoldItalicWoff from '../assets/fonts/Politica-ExtraBoldItalic.woff2';
import PoliticaItalicEot from '../assets/fonts/Politica-Italic.eot';
import PoliticaItalicSvg from '../assets/fonts/Politica-Italic.svg';
import PoliticaItalicTtf from '../assets/fonts/Politica-Italic.ttf';
import PoliticaItalicWoff2 from '../assets/fonts/Politica-Italic.woff';
import PoliticaItalicWoff from '../assets/fonts/Politica-Italic.woff2';
import SourceCodeProRegular from '../assets/fonts/SourceCodePro-Regular.ttf';
import TradeGothicLTStdBold from '../assets/fonts/TradeGothicLTStd-Bold.otf';
import TroikaRegular from '../assets/fonts/troika.otf';
import YantramanavBlack from '../assets/fonts/Yantramanav-Black.ttf';
import YantramanavBold from '../assets/fonts/Yantramanav-Bold.ttf';
import YantramanavLight from '../assets/fonts/Yantramanav-Light.ttf';
import YantramanavMedium from '../assets/fonts/Yantramanav-Medium.ttf';
import YantramanavRegular from '../assets/fonts/Yantramanav-Regular.ttf';
import YantramanavThin from '../assets/fonts/Yantramanav-Thin.ttf';

const fontsLoaderStr = `
  @font-face {
    font-family: "BettingBebasNeueRegular";
    src: url(${BebasNeueEot}) format("embedded-opentype"),
      url(${BebasNeueWoff}) format("woff"),
      url(${BebasNeueTtf}) format("truetype"),
      url(${BebasNeueSvg}) format("svg");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "BettingDropDeadGorgeous";
    src: url(${DropDeadGorgeousTtf}) format("truetype");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "BettingPoliticaItalic";
    src: url(${PoliticaItalicEot}) format("embedded-opentype"),
      url(${PoliticaItalicWoff}) format("woff2"),
      url(${PoliticaItalicWoff2}) format("woff"),
      url(${PoliticaItalicTtf}) format("truetype"),
      url(${PoliticaItalicSvg}) format("svg");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "BettingPoliticaExtraBoldItalic";
    src: url(${PoliticaExtraBoldItalicEot}) format("embedded-opentype"),
      url(${PoliticaExtraBoldItalicWoff}) format("woff2"),
      url(${PoliticaExtraBoldItalicWoff2}) format("woff"),
      url(${PoliticaExtraBoldItalicTtf}) format("truetype"),
      url(${PoliticaExtraBoldItalicSvg}) format("svg");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "BettingPoliticaExtraBold";
    src: url(${PoliticaExtraBoldEot}) format("embedded-opentype"),
      url(${PoliticaExtraBoldWoff}) format("woff2"),
      url(${PoliticaExtraBoldWoff2}) format("woff"),
      url(${PoliticaExtraBoldTtf}) format("truetype"),
      url(${PoliticaExtraBoldSvg}) format("svg");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "BettingPoliticaBold";
    src: url(${PoliticaBoldEot}) format("embedded-opentype"),
      url(${PoliticaBoldWoff}) format("woff2"),
      url(${PoliticaBoldWoff2}) format("woff"),
      url(${PoliticaBoldTtf}) format("truetype"),
      url(${PoliticaBoldSvg}) format("svg");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowRegularTtf}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowItalicTtf}) format('truetype');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowMediumTtf}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowMediumItalicTtf}) format('truetype');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowSemiBoldTtf}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowSemiBoldItalicTtf}) format('truetype');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowBoldTtf}) format('truetype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingArchivoNarrow';
    src: url(${ArchivoNarrowBoldItalicTtf}) format('truetype');
    font-weight: 700;
    font-style: italic;
  }

  @font-face {
    font-family: 'BettingCountbach';
    src: url(${CountbachWoff2}) format('woff2'),
      url(${CountbachWoff}) format("woff"),
      url(${CountbachOtf}) format('opentype');
    font-weight: 800;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingYantramanav';
    src: url(${YantramanavBlack}) format('truetype');
    font-weight: bolder;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingYantramanav';
    src: url(${YantramanavBold}) format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingYantramanav';
    src: url(${YantramanavMedium}) format('truetype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingYantramanav';
    src: url(${YantramanavRegular}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingYantramanav';
    src: url(${YantramanavLight}) format('truetype');
    font-weight: lighter;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingYantramanav';
    src: url(${YantramanavThin}) format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingKalam';
    src: url(${KalamLight}) format('truetype');
    font-weight: lighter;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingKalam';
    src: url(${KalamRegular}) format('truetype');
    font-weight: 100;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingKalam';
    src: url(${KalamBold}) format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Betting28DaysLater';
    src: url(${Font28DaysLater}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'MoneyTime';
    src: url(${MoneyTime}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "SourceCodeProRegular";
    src: url(${SourceCodeProRegular}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingTroika';
    src: url(${TroikaRegular}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'BettingTradeGothicLTStd';
    src: url(${TradeGothicLTStdBold}) format('opentype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'KabelHasbro';
    src: url(${KBLH45}) format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'KabelHasbro';
    src: url(${KBLH55}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'KabelHasbro';
    src: url(${KBLH65}) format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'KabelHasbro';
    src: url(${KBLH75}) format('opentype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'KabelHasbro';
    src: url(${KBLH85}) format('opentype');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'ChangaOne';
    src: url(${ChangaOneRegular}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }
`;

// we use a style node to avoid glitch with createGlobalStyle from styled-components
// https://github.com/react-boilerplate/react-boilerplate/issues/2552
// eslint-disable-next-line react/display-name
export default () => <style>{fontsLoaderStr}</style>;
